import type { Currency } from '@backmarket/http-api'

export function getDefaultFilterValues(sellerCurrency: Currency) {
  return {
    timeframe: 'YEAR_TO_DATE',
    currency: sellerCurrency,
  }
}
